import * as React from 'react';
const RightArrow = ({className}) => (
    <svg className={className} width="44" height="50" viewBox="0 0 44 50" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M44 0H0V14.9351H23.5L0 37.013V50H13L44 14.9351V0Z" fill="#D9D9D9"/>
<path d="M30 50H44V33V24.5L30 39.5V50Z" fill="#D9D9D9"/>
</svg>

    
);
export default RightArrow;
